import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-76" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-md border border-navy/15 bg-white p-3 shadow-sm" data-id="element-77" data-mp="1o3dmib9hgbqm">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-volt sm:h-10 sm:w-10" aria-hidden="true" data-id="element-78" data-mp="22126lgvq7eum" />
        <div data-id="element-79" data-mp="19e7q0v214zmf">
          <h2 className="text-base leading-tight text-navy sm:text-2xl" data-id="element-80" data-mp="19fskyls9akkt">
            YOUR PURCHASE IS 100% PROTECTED
          </h2>
          <p className="mt-1 text-[13px] font-medium leading-snug text-carbon/85" data-id="element-81" data-mp="14hh8e3aktvyw">
            Explore INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™ for 7 days. Access
            the complete 6-module troubleshooting system and all 5 professional
            bonuses.
          </p>
          <p className="mt-1 text-[13px] font-medium leading-snug text-carbon/85" data-id="element-82" data-mp="qmye6f4sdyro">
            If it isn’t right for you, contact us within 7 days for a full
            refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}